import { useMemo } from "react";

import { PrintDiscountTBodyLayout, PrintDiscountTHeadLayout, PrintSectionLayout } from "../../layout";

import type { QueryData } from "../../../model";

type VoucherCase = {
	type: "voucher";
	vouchers: QueryData["aliveItemsPerReservation"]["vouchers"];
};

/**
 * QueryData から参照したかったが、オプショナルとなってしまう為、別途定義する
 */
type Discount = {
	name: string;
	discountPrice: number;
};
type DiscountCase = {
	type: "discount";
	discount: Discount;
};

type Props = VoucherCase | DiscountCase;

export const DiscountOfPrintComposition = (props: Props) => {
	const titleText = useMemo(() => (props.type === "discount" ? "ディスカウント" : "宿泊券"), [props.type]);

	return (
		<PrintSectionLayout titleChildren={<p className="text-sm font-bold">{titleText}</p>}>
			<div>
				<PrintDiscountTHeadLayout />

				{props.type === "discount" ? (
					<PrintDiscountTBodyLayout name={props.discount.name} discountPrice={props.discount.discountPrice} />
				) : (
					<>
						{props.vouchers.map((voucher, index) => (
							<PrintDiscountTBodyLayout
								key={index}
								name={voucher.name}
								discountPrice={voucher.voucherPrice}
							/>
						))}
					</>
				)}
			</div>
		</PrintSectionLayout>
	);
};
